import React, { useContext } from "react";
import { ThemeContext } from "../lib/main-context";
import { useTranslation } from "../i18n/TranslationProvider";
import { translateOr } from "../i18n/translateData";

import ReactECharts from "echarts-for-react";

import { useHistory } from "react-router-dom";

import theme from "../index.scss";

import { subDays, parseISO } from "date-fns";

const DoughnutTrigger = ({ data, days, userName, splitView }) => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();

  const cutoff = subDays(new Date(), days);
  const recentData = data?.filter(
    (item) => parseISO(item.symptom_date) >= cutoff
  );

  const triggerSubcategoryCount = recentData?.reduce((acc, obj) => {
    const subcategory = obj.subcategory;
    acc[subcategory] = (acc[subcategory] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.keys(triggerSubcategoryCount).map((key) => {
    return {
      value: triggerSubcategoryCount[key],
      name: key.charAt(0).toUpperCase() + key.slice(1),
    };
  });

  const history = useHistory();

  const handleChartClick = (params) => {
    history.push({
      pathname: "/triggerDetailsChart",
      state: {
        triggerType: params.data.name,
        fromTriggerDetailsChart: true,
        days: days,
      }, // Pass parameters as state
    });
  };

  const onEvents = {
    click: handleChartClick,
  };

  const option = {
    title: {
      text: t("dashboard.doughnutTrigger"),
      subtext:
        chartData.length == 0
          ? `${t("dashboard.noTrackingData.0")}\n${t("dashboard.noTrackingData.1")}`
          : `${splitView ? `(${userName})` : ""}`,
      subtextStyle: {
        fontSize: "1.1rem",
        color: dark ? theme.darkModeText : theme.primary,
      },
      left: "center",
      // padding: [0, 0, 40, 0],
      textStyle: {
        fontSize: "1.2rem",
        color: dark ? theme.darkModeText : theme.black,
      },
    },
    tooltip: {
      trigger: "item",
      formatter: function (params) {
        const percentage = params.percent.toFixed(1);
        const category = translateOr(t, `dashboard.triggerCategory.${params.name}`, params.name);
        return `${category}: ${percentage}%`;
      },
    },
    legend: {
      show: false,
      orient: "vertical",
      left: "left",
    },
    label: {
      show: true,
      // formatter: '{b}: {d}%'
      fontSize: 16,
      color: dark ? theme.darkModeText : theme.black,
      formatter: function (params) {
        const percentage = params.percent.toFixed(1);
        const category = translateOr(t, `dashboard.triggerCategory.${params.name}`, params.name);
        return `${category}: ${percentage}%`;
      },
    },
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["30%", "50%"],
        data: chartData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };
  return (
    <ReactECharts
      option={option}
      onEvents={onEvents}
      style={{ minHeight: "25vh" }}
    />
  );
};

export default DoughnutTrigger;